module.exports = __webpack_public_path__ + "img/successful.9356f4d9.png";